import { find, propEq } from 'ramda';
export default (uri, xs) => find(propEq('uri', uri), xs);
